import React from 'react';

function Error() {
    return ( 
        <div className="error-cover">
            <h1>ERROR PAGE</h1>
        </div>
     );
}

export default Error;